<template>
  <div>

    <loading-indicator v-if="isLoading"></loading-indicator>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="isDataLoaded && equipment.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Item</th>
          <th scope="col">Character</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="item in sortedEquipment">
        <tr :key="item.proto_id">
          <td>
            {{item.proto_id | getProtoStr}}
          </td>
          <td>
            {{item.character_id | getOptionalProtoStr}}
          </td>
        </tr>
        </template>
      </tbody>
    </table>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import { compareProtoIdsByAlias } from '../util';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerEquipment',

  components: {
    LoadingIndicator
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      equipment: null,
    };
  },

  computed: {
    isDataLoaded() {
      return this.equipment !== null;
    },

    message() {
      if(this.equipment !== null && this.equipment.length === 0) {
        return 'This player has no equipment.';
      }
      return null;
    },

    sortedEquipment() {
      return this.equipment.slice().sort((a, b) => compareProtoIdsByAlias(a.proto_id, b.proto_id))
    },
  },

  created() {
    this.isLoading = true;
    HTTP.get('/player/' + this.playerId + '/equipment')
    .then(response => {
      this.equipment = [];
      for(var i = 0; i < response.data.data.length; ++i) {
        const item = response.data.data[i];
        this.equipment.push(item);
      }
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};
</script>
